import React, { createContext, ReactNode } from 'react';
import { track } from '../helpers/analytics';

export interface AnalyticsProps {
  [K: string]: boolean | number | string | null | undefined;
}

interface Props {
  children: ReactNode | ReactNode[];
  baseProps?: AnalyticsProps;
}

export const TrackingContext = createContext({
  track,
});

export const TrackingProvider: React.FC<Props> = ({ children, baseProps = {} }) => (
  <TrackingContext.Provider
    value={{
      track: (event, properties): void => {
        track(event, {
          ...properties,
          ...baseProps,
        });
      },
    }}
  >
    {children}
  </TrackingContext.Provider>
);
